export default {
  routes: [
    {
      name: 'workplaces',
      path: '/directory/workplace',
      component: () => import('./views/TheWorkplacesPages.vue'),

    },

    {
      name: 'workplace',
      path: '/directory/workplace/:uuid',
      component: () => import('./views/TheWorkplacePage.vue'),
    },
  ]
}